// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"e0092c7c","78":"7418c051","93":"f8691077","191":"b18dd7d3","220":"efe1b0ba","274":"1dc0b849","714":"24346305","718":"5683713e","944":"cceaef39"}[chunkId] + ".chunk.js";
};